<template>
	<div>
		<div class="mt-5 pt-4">

      <nav class="mb-4" style="--bs-breadcrumb-divider: url(&#34;data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='10'%3E%3Cpath d='M2.5 0L1 1.5 3.5 4 1 6.5 2.5 8l4-4-4-4z' fill='black'/%3E%3C/svg%3E&#34;);" aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item" style="font-size:24px; line-height: 24px; font-weight:900; color:#435666;"><strong>Settings</strong></li>
          <li class="breadcrumb-item" style="font-size:24px; line-height: 24px; font-weight:900; color:#435666;"><strong>Library</strong></li>
          <li class="breadcrumb-item active" aria-current="page" style="font-size:24px; line-height: 24px; font-weight:300; color:#435666;">Manage Quiz</li>
        </ol>
      </nav>

			<div class="mt-2">
				<div class="row">
					<div class="col-md-12">
            <div class="card shadow-sm border-0 rounded-4 main-app-card mt-1">
							<div class="card-body p-4 bg-light-surface">

                <div class="d-flex justify-content-between align-items-center mb-4 mt-2">
                  <button type="button" class="btn btn-outline-secondary btn-sm rounded-pill px-3 shadow-sm d-flex align-items-center" @click="$router.go(-1)">
                    <i class="fas fa-arrow-left me-2"></i> Back to Library
                  </button>
                  <button type="button" class="btn btn-theme text-white btn-sm rounded-pill px-4 shadow-sm fw-bold d-flex align-items-center" @click="dialog = true">
                    <i class="fas fa-plus me-2"></i> Add Question
                  </button>
                </div>

                <div v-if="loading" class="text-center align-middle py-5">
                    <img src="@/assets/img/loading.svg">
                </div>

                <div class="table-responsive bg-white rounded-3 border" style="overflow-x: hidden;" v-else>
                  <table class="table table-hover align-middle mb-0">
                    <thead class="table-light align-middle text-start">
                      <tr>
                        <th style="width: 25%;">Question</th>
                        <th style="width: 14%;">Option 1</th>
                        <th style="width: 14%;">Option 2</th>
                        <th style="width: 14%;">Option 3</th>
                        <th style="width: 14%;">Option 4</th>
                        <th class="text-center" style="width: 10%;">Answer</th>
                        <th class="text-end" style="width: 9%; white-space: nowrap;">Actions</th>
                      </tr>
                    </thead>
                    <tbody class="align-middle text-dark">
                      <tr v-if="questions.length === 0">
                        <td colspan="7" class="text-center text-muted py-4">No questions added to this quiz yet.</td>
                      </tr>
                      <tr v-for="(item, index) in questions" :key="index">
                          <td class="fw-bold">{{ item.question }}</td>
                          <td><span class="text-muted small">{{ item.option_1}}</span></td>
                          <td><span class="text-muted small">{{ item.option_2}}</span></td>
                          <td><span class="text-muted small">{{ item.option_3}}</span></td>
                          <td><span class="text-muted small">{{ item.option_4}}</span></td>
                          <td class="text-center">
                            <span class="badge bg-theme text-white rounded-pill px-3 py-2">Option {{ item.answer }}</span>
                          </td>
                          <td class="text-end align-middle">
                            <div class="d-flex justify-content-end align-items-center">
                              <button type="button" class="btn btn-sm btn-light btn-circle me-2" title="Edit Question" @click="editQuestion(item)"><i class="far fa-edit text-info"></i></button>
                              <button type="button" class="btn btn-sm btn-light btn-circle" title="Delete Question"  @click="deleteQuestion(item)"><i class="fas fa-trash text-danger"></i></button>
                            </div>
                          </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

							</div>
						</div>
					</div>
				</div>
			</div>

		</div>

    <vue-final-modal v-model="dialog" classes="modal-overlay-container" content-class="modern-modal-content">
      <div class="modal-header">
        <div class="header-text-container">
          <div class="title-wrapper">
            <div class="title-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10"></circle>
                <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
                <line x1="12" y1="17" x2="12.01" y2="17"></line>
              </svg>
            </div>
            <h5 class="modal-title">{{ formTitle }}</h5>
          </div>
        </div>
        <button type="button" class="close-button" @click="close" aria-label="Close">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>

      <div class="modal-body custom-scrollbar p-4">

        <div class="setting-item">
          <label>Question <span class="text-danger">*</span></label>
          <textarea class="form-control" rows="3" placeholder="Enter the quiz question..." v-model="editedQuestion.question" :class="{ 'border-danger': v$.editedQuestion.question.$errors.length }" @blur="v$.editedQuestion.question.$touch()"></textarea>
          <div class="text-danger mt-1 ms-1" v-for="error of v$.editedQuestion.question.$errors" :key="error.$uid">
            <div style="font-size: 0.75rem; font-weight: 600;">Question is required.</div>
          </div>
        </div>

        <div class="settings-grid mt-4">
          <div class="setting-item">
            <label>Option 1 <span class="text-danger">*</span></label>
            <textarea rows="2" class="form-control" placeholder="First answer option" v-model="editedQuestion.option_1" :class="{ 'border-danger': v$.editedQuestion.option_1.$errors.length }" @blur="v$.editedQuestion.option_1.$touch()"></textarea>
          </div>
          <div class="setting-item">
            <label>Option 2 <span class="text-danger">*</span></label>
            <textarea rows="2" class="form-control" placeholder="Second answer option" v-model="editedQuestion.option_2" :class="{ 'border-danger': v$.editedQuestion.option_2.$errors.length }" @blur="v$.editedQuestion.option_2.$touch()"></textarea>
          </div>
          <div class="setting-item">
            <label>Option 3 <span class="text-danger">*</span></label>
            <textarea rows="2" class="form-control" placeholder="Third answer option" v-model="editedQuestion.option_3" :class="{ 'border-danger': v$.editedQuestion.option_3.$errors.length }" @blur="v$.editedQuestion.option_3.$touch()"></textarea>
          </div>
          <div class="setting-item">
            <label>Option 4 <span class="text-danger">*</span></label>
            <textarea rows="2" class="form-control" placeholder="Fourth answer option" v-model="editedQuestion.option_4" :class="{ 'border-danger': v$.editedQuestion.option_4.$errors.length }" @blur="v$.editedQuestion.option_4.$touch()"></textarea>
          </div>
        </div>

        <div class="setting-item mt-4 pb-2">
          <label>Correct Answer <span class="text-danger">*</span></label>
          <select class="form-select" v-model="selectedAnswer" :class="{ 'border-danger': v$.selectedAnswer.$errors.length }" @blur="v$.selectedAnswer.$touch()">
            <option :value="null" disabled hidden>Choose the correct option...</option>
            <option v-for="answer in answerItems" :key="answer.value" :value="answer.value">{{ answer.label }}</option>
          </select>
          <div class="text-danger mt-1 ms-1" v-for="error of v$.selectedAnswer.$errors" :key="error.$uid">
            <div style="font-size: 0.75rem; font-weight: 600;">You must select a correct answer.</div>
          </div>
        </div>

      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" @click="close">Cancel</button>
        <button type="button" class="btn btn-primary" @click="saveQuestion">{{ editedIndex == -1 ? 'Save Question' : 'Update Question' }}</button>
      </div>
    </vue-final-modal>

    <vue-final-modal v-model="dialogDelete" classes="modal-overlay-container" content-class="modern-modal-content-sm">
      <div class="modal-body text-center p-5">
        <div class="delete-icon-wrapper mx-auto mb-4">
          <i class="fas fa-exclamation-triangle text-danger fs-1"></i>
        </div>
        <h4 class="text-dark fw-bold mb-3">Delete Question</h4>
        <p class="text-muted mb-4">Are you sure you want to permanently delete this question? This action cannot be undone.</p>
        <div class="d-flex justify-content-center gap-3">
          <button type="button" class="btn btn-secondary px-4" @click="closeDeleteDialog">Cancel</button>
          <button type="button" class="btn btn-danger px-4 fw-bold" @click="deleteConfirm">Yes, Delete</button>
        </div>
      </div>
    </vue-final-modal>

	</div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'

  export default {
    name: 'Dashboard',

    setup () {
      return { v$: useVuelidate() }
    },

    validations () {
      return {
        editedQuestion: {
          question: {required},
          option_1: {required},
          option_2: {required},
          option_3: {required},
          option_4: {required},
        },
        selectedAnswer: {required}
      }
    },

    data() {
      return {
        search: '',
        questions: [],
        editedQuestion: {
            question: '',
            option_1: '',
            option_2: '',
            option_3: '',
            option_4: '',
            answer: null,
        },
        defaultQuestion: {
            question: '',
            option_1: '',
            option_2: '',
            option_3: '',
            option_4: '',
            answer: null,
        },
        answerItems: [
            {label: 'First Option', value: 1},
            {label: 'Second Option', value: 2},
            {label: 'Third Option', value: 3},
            {label: 'Fourth Option', value: 4},
        ],
        selectedAnswer: null,
        editedIndex: -1,
        dialog: false,
        dialogDelete: false,
        buttonSave: 'save',
        loading: false,
        editedItem: {},
      }
    },

    async created() {
      await this.getData()
    },

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New Quiz Question' : 'Edit Quiz Question'
      },

      isOrgModule() {
        return this.$route.path.includes('module');
      },
      apiBaseUrl() {
        return this.isOrgModule ? `/orgadmin/trainings/organisations/${this.orgID}` : `/supadmin/trainings`;
      },
      fetchUrl() {
        return this.isOrgModule ? `${this.apiBaseUrl}/modules/${this.$route.params.id}/questions` : `${this.apiBaseUrl}/videos/${this.$route.params.id}/questions`;
      },
      orgID() {
				if (this.$helper.isVertexAnalyst()) {
					return this.$store.state.user.organisation.id;
				}
				return this.$helper.setOrganisationID();
			},
    },

    methods: {
      getData(){
        this.loading = true;
        this.$axios.get(this.fetchUrl)
        .then((response) => {
          if (response.data.success){
            this.questions = response.data.questions;
          } else {
            this.$toast.error(response.data.message)
          }
        })
        .catch()
        this.loading = false;
      },

      editQuestion(item) {
            this.editedIndex = this.questions.indexOf(item)
            this.editedQuestion = Object.assign({}, item)
            this.selectedAnswer = item.answer
            this.id = item.ID
            this.dialog = true
        },

      deleteQuestion(item){
        this.dialogDelete = true;
        this.editedIndex = this.questions.indexOf(item);
        this.editedItem = item
      },

      deleteConfirm() {
        this.$axios
        .delete(`${this.apiBaseUrl}/questions/${this.editedItem.ID}`)
        .then((response) => {
            if (response.data.success) {
              this.getData()
              this.closeDeleteDialog()
              this.$toast.success(response.data.message)
            } else {
              this.$toast.error(response.data.message)
            }
        })
        .catch();
      },

      closeDeleteDialog() {
        this.dialogDelete = false;
        this.editedQuestion = Object.assign({}, this.defaultQuestion);
        this.editedIndex = -1;
        this.editedItem = null;
      },

      saveQuestion(){
        this.v$.editedQuestion.question.$touch();
        this.v$.editedQuestion.option_1.$touch();
        this.v$.editedQuestion.option_2.$touch();
        this.v$.editedQuestion.option_3.$touch();
        this.v$.editedQuestion.option_4.$touch();
        this.v$.selectedAnswer.$touch();

        if (this.v$.editedQuestion.question.$invalid ||
          this.v$.editedQuestion.option_1.$invalid ||
          this.v$.editedQuestion.option_2.$invalid ||
          this.v$.editedQuestion.option_3.$invalid ||
           this.v$.editedQuestion.option_4.$invalid ||
           this.v$.selectedAnswer.$invalid) return

        let data = {
            question: this.editedQuestion.question,
            option_1: this.editedQuestion.option_1,
            option_2: this.editedQuestion.option_2,
            option_3: this.editedQuestion.option_3,
            option_4: this.editedQuestion.option_4,
            answer: this.selectedAnswer,
        }

        if (this.editedIndex > -1) {
          this.$axios.put(`${this.apiBaseUrl}/questions/${this.id}`, data)
          .then((response) => {
              if (response.data.success){
                this.editedQuestion.answer = this.selectedAnswer
                Object.assign(
                    this.questions[this.editedIndex],
                    this.editedQuestion
                  );
                this.selectedAnswer = null;
              }
              this.showSaveUpdateResponse(response);
          })
          .catch()

        } else {
          this.$axios.post(this.fetchUrl, data)
          .then((response) => {
            if (response.data.success){
              this.editedQuestion.answer = this.selectedAnswer;
              this.questions.push(this.editedQuestion);
              this.selectedAnswer = null;
              this.showSaveUpdateResponse(response);
            }
              this.getData();
            })
          .catch()
        }

        this.v$.$reset();
      },

      showSaveUpdateResponse(response) {
          if (response.data.success) {
              this.$toast.success(response.data.message);
              this.close();
          } else {
              this.$toast.error(response.data.message);
          }
      },

      close () {
        this.dialog = false
          this.$nextTick(() => {
            this.editedQuestion = Object.assign({}, this.defaultQuestion)
            this.selectedAnswer = null;
            this.editedIndex = -1
        })
        this.v$.$reset();
      },
    }
  }
</script>

<style scoped>
/* Page Level Styles */
.bg-light-surface { background-color: #f8fafc; }
.main-app-card { overflow: hidden; }

/* Table Overrides */
td { white-space: normal !important; word-wrap: break-word; }
table { table-layout: fixed; }
.btn-circle { width: 32px; height: 32px; padding: 0; border-radius: 50%; display: inline-flex; align-items: center; justify-content: center; border: 1px solid #e2e8f0; transition: all 0.2s; }
.btn-circle:hover { background-color: #e2e8f0; }

/* Brand Colors */
.text-theme { color: #00a0c1 !important; }
.bg-theme { background-color: #00a0c1 !important; border-color: #00a0c1 !important; }
.btn-theme { background-color: #00a0c1 !important; border-color: #00a0c1 !important; transition: all 0.2s;}
.btn-theme:hover { background-color: #008da8 !important; border-color: #008da8 !important; }

/* Modal Container Overrides */
:deep(.modal-overlay-container) {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(15, 23, 42, 0.6);
  backdrop-filter: blur(4px);
  z-index: 1000;
}

:deep(.modern-modal-content) {
  background: white;
  border-radius: 12px;
  width: 100%;
  max-width: 600px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  border: none !important;
  padding: 0;
  margin: 0 1rem;
  overflow: hidden;
  max-height: 90vh;
}

:deep(.modern-modal-content-sm) {
  background: white;
  border-radius: 16px;
  width: 100%;
  max-width: 400px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  border: none !important;
  padding: 0;
  margin: 0 1rem;
  overflow: hidden;
}

/* Modal Header */
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.5rem;
  border-bottom: 1px solid #f1f5f9;
  background-color: #ffffff;
}

.title-wrapper { display: flex; align-items: center; gap: 0.75rem; }
.title-icon { color: #00a0c1; display: flex; align-items: center; justify-content: center; background: rgba(0, 160, 193, 0.1); padding: 8px; border-radius: 8px; }
.modal-title { color: #1e293b; margin: 0; font-size: 1.15rem; font-weight: 700; letter-spacing: -0.01em; }
.close-button { background: #f1f5f9; border: none; width: 32px; height: 32px; border-radius: 50%; display: flex; align-items: center; justify-content: center; cursor: pointer; color: #94a3b8; transition: all 0.2s; padding: 0; }
.close-button:hover { background-color: #fee2e2; color: #dc3545; transform: rotate(90deg); }

/* Modal Body */
.modal-body { overflow-y: auto; }
.custom-scrollbar::-webkit-scrollbar { width: 6px; }
.custom-scrollbar::-webkit-scrollbar-track { background: #f1f5f9; }
.custom-scrollbar::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 4px; }
.custom-scrollbar::-webkit-scrollbar-thumb:hover { background: #94a3b8; }

/* Modern Inputs (No more floating labels!) */
.settings-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.25rem;
}

.setting-item { margin-bottom: 0; }
.setting-item label {
  display: block;
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.025em;
  color: #64748b;
  margin-bottom: 0.5rem;
  font-weight: 700;
}

/* 🚨 FIX: Removed appearance: auto; to kill the double arrow */
.form-control, .form-select {
  width: 100%;
  padding: 0.7rem 1rem;
  border: 1.5px solid #e2e8f0;
  border-radius: 8px;
  font-size: 0.95rem;
  color: #1e293b;
  background-color: #ffffff;
  transition: all 0.2s;
}

textarea.form-control { resize: vertical; min-height: 45px; }

.form-control:focus, .form-select:focus {
  border-color: #00a0c1;
  outline: none;
  box-shadow: 0 0 0 3px rgba(0, 160, 193, 0.15);
}

/* Modal Footer */
.modal-footer {
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid #f1f5f9;
  padding: 1rem 1.5rem;
  gap: 0.75rem;
  background-color: #f8fafc;
}

.btn { padding: 0.5rem 1.25rem; border-radius: 8px; font-size: 0.9rem; font-weight: 600; cursor: pointer; transition: all 0.2s; border: 1px solid transparent; }
.btn-primary { background-color: #00a0c1; color: white; border-color: #00a0c1; }
.btn-primary:hover { background-color: #008da8; border-color: #008da8; }
.btn-secondary { background-color: white; color: #64748b; border-color: #e2e8f0; }
.btn-secondary:hover { background-color: #f8fafc; border-color: #cbd5e1; color: #1e293b; }

/* Delete Dialog Specifics */
.delete-icon-wrapper {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: #fef2f2;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btn-danger { background-color: #ef4444; border-color: #ef4444; color: white;}
.btn-danger:hover { background-color: #dc2626; border-color: #dc2626;}

@media screen and (max-width: 768px) {
  .settings-grid { grid-template-columns: 1fr; }
}
</style>